module.exports = __webpack_public_path__ + "static/mourina-0676c0552ef963e70218d4455f52c371.png";